/* eslint-disable react/prop-types */
import React from 'react'
import { Trans, withTranslation } from 'react-i18next'
import BaseModal from '../../common/BaseModal'

import './DrillFailedValidationModal.scss'

class DrillFailedValidationModal extends React.Component {
  render() {
    const { fails, close, is_drill, navigate, navigateText, t } = this.props
    return (
      <BaseModal close={close}>
        <div id='DrillFailedValidationModal'>
          <h4>{t('drills.failedValidationModal.title')}</h4>
          <p className='subtitle'>
            {t('drills.failedValidationModal.subtitle')}
          </p>
          <div
            style={{
              width: '100%',
              height: 1,
              background: 'rgba(95, 111, 124, 0.5)',
              marginBottom: 5,
            }}
          />
          <div className='fail-container'>
            {this._renderFails(fails, is_drill)}
          </div>
          {navigateText ? (
            <div className='two-button-container'>
              <button className='cancel-button' onClick={close}>
                {t('common.cancel')}
              </button>
              <button className='navigate-button' onClick={navigate}>
                {navigateText}
              </button>
            </div>
          ) : (
            <button className='full-length-btn' onClick={close}>
              {t('drills.failedValidationModal.ok')}
            </button>
          )}
        </div>
      </BaseModal>
    )
  }

  _renderFails = (fails, is_drill) => {
    const orange = { s: <span className='orange-text' /> }
    const arr = []
    // eslint-disable-next-line complexity
    fails.forEach((fail, i) => {
      switch (fail) {
        case 'title':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey={
                  is_drill
                    ? 'drills.failedValidationModal.reasons.titleDrill'
                    : 'drills.failedValidationModal.reasons.titleActivity'
                }
                components={orange}
              />
            </p>
          )
          break
        case 'description':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey={
                  is_drill
                    ? 'drills.failedValidationModal.reasons.descriptionDrill'
                    : 'drills.failedValidationModal.reasons.descriptionActivity'
                }
                components={orange}
              />
            </p>
          )
          break
        case 'equipment':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey={
                  is_drill
                    ? 'drills.failedValidationModal.reasons.equipmentDrill'
                    : 'drills.failedValidationModal.reasons.equipmentActivity'
                }
                components={orange}
              />
            </p>
          )
          break
        case 'steps':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey={
                  is_drill
                    ? 'drills.failedValidationModal.reasons.stepsDrill'
                    : 'drills.failedValidationModal.reasons.stepsActivity'
                }
                components={orange}
              />
            </p>
          )
          break
        case 'blank_equipment':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey='drills.failedValidationModal.reasons.blankEquipment'
                components={orange}
              />
            </p>
          )
          break
        case 'blank_steps':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey='drills.failedValidationModal.reasons.blankSteps'
                components={orange}
              />
            </p>
          )
          break
        case 'content':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey={
                  is_drill
                    ? 'drills.failedValidationModal.reasons.contentDrill'
                    : 'drills.failedValidationModal.reasons.contentActivity'
                }
                components={orange}
              />
            </p>
          )
          break
        case 'privacy':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey={
                  is_drill
                    ? 'drills.failedValidationModal.reasons.privacyDrill'
                    : 'drills.failedValidationModal.reasons.privacyActivity'
                }
                components={orange}
              />
            </p>
          )
          break
        case 'draft_title':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey={
                  is_drill
                    ? 'drills.failedValidationModal.reasons.draftTitleDrill'
                    : 'drills.failedValidationModal.reasons.draftTitleActivity'
                }
                components={orange}
              />
            </p>
          )
          break
        case 'numeric_scoring_measurement':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey='drills.failedValidationModal.reasons.numericScoringMeasurement'
                components={orange}
              />
            </p>
          )
          break
        case 'star_high_low_label':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey='drills.failedValidationModal.reasons.starHighLowLabel'
                components={orange}
              />
            </p>
          )
          break
        case 'star_question_to_ask':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey='drills.failedValidationModal.reasons.starQuestionToAsk'
                components={orange}
              />
            </p>
          )
          break
        case 'drill_tier':
          arr.push(
            <p key={i} className='fail-text'>
              <Trans
                i18nKey='drills.failedValidationModal.reasons.drillTier'
                components={orange}
              />
            </p>
          )
          break
        default:
          arr.push(
            <p key={i} className='fail-text'>
              {this.props.t('drills.failedValidationModal.reasons.default')}
            </p>
          )
          break
      }
    })
    return arr
  }
}

export default withTranslation()(DrillFailedValidationModal)
